import './App.css';
import Navbar from './shared/navbar'
import Search from './components/search';

function App() {
  return (
    <div className="App">
      <Navbar/>
      <Search/>
    </div>
  );
}

export default App;
